var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tableWrap"
  }, [_c('el-table', {
    staticClass: "wdb100",
    attrs: {
      "data": _vm.itemList,
      "border": "",
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "category",
      "label": "Category",
      "align": "center",
      "width": "158px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.invoiceItemCategoryFormat(scope.row.category)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "Description",
      "align": "center",
      "min-width": "200px"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "originalCurrency",
      "label": "Currency",
      "align": "center",
      "width": "100px"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "originalAmount",
      "label": "Orig. Amount",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.currencyAndAmountFormat(scope.row.originalCurrency, scope.row.originalAmount)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "exchangeRate",
      "label": "Ex Rate",
      "align": "center",
      "width": "180px"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "billingAmount",
      "label": "Amount",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.currencyAndAmountFormat(_vm.billingCurrency, scope.row.billingAmount)))])];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }